import React, { useCallback, useMemo, useState } from "react"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { Col, Row } from "react-bootstrap"
import classNames from "classnames"
import { Link } from "gatsby"
/**
 * Internal dependencies.
 */
import ImageTransform from "@components/common/ggfx-client/module/components/image-transform";
import VideoPlaceholder from "../video-placeholder/video-placeholder"
import LinkIcon from "../link-icon/link-icon"
import Modal from "../modal/modal"
import "./styles/_index.scss"
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import imageConfig from "../../../static/images/config.json"
import noImg from "../../../src/images/no-image.png"
import Noimg from "../no-img/Noimg"
const NewHomePropertyBox = ({
  children,
  bed,
  bathroom,
  room,
  badge,
  images,
  images1,
  video,
  videoPlaceholder,
  imagetransforms,
  id,
  title,
  map,
  url,
  onClick,
  collection,
  nostats,
  hidebtn,
  pstatustype,
  bedroom_text
}) => {
  const [modalShow, setModalShow] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const imageArray = video && videoPlaceholder ? images?.slice(0, 3) : images

  const closeModal = useCallback(() => setModalShow(false), [])

  const onGalleryOpen = useCallback((gallery, index) => {
    setModalContent(<Modal.Gallery gallery={gallery} index={index} />)
    setModalShow(true)
  }, [])

  let processedImages = JSON.stringify({});
  if (imagetransforms?.upload_images_Transforms) {
    processedImages = imagetransforms?.upload_images_Transforms;
  }
  // const slides = useMemo(() => {
  //   const items = []
  //   if (video) {
  //     items.push({
  //       type: "video",
  //       value: video,
  //     })
  //   }
  //   imageArray?.map((item, index) => {
  //     items.push({
  //       type: "image",
  //       value: item.node.childImageSharp.gatsbyImageData,
  //     })
  //   })
  //   return items
  // }, [images])

  return (
    <div className={`${map ? `grid` : null} property-box`}>
      {/* {JSON.stringify(images)} */}
      {badge && <div className={badge === "Sold Subject To Contract" || badge === "Let Agreed" ? "property-box__badge yellow" : "property-box__badge"}>{badge}</div>}
      <div className="property-box__images">
        <div className="property-box-image">
          <button className="video-button hover-zoom-self"
          >
            {images &&
                  images ?
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    <ImageTransform
                      imagesources={images?.url}
                      // renderer="srcSet"
                      imagename={collection === "newhomes" ? "offplan.upload_images.searchResults1" : "property.images.searchResults1"}
                      attr={{ alt: 'New Homes', className: "no-image-style" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  </Link>
                  :
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults1" />
                  </Link>
                 }




          </button>
        </div>
        {images1?.length > 0 ?
              // images1?.map((item, index) => (
                images1?.length === 1 ?
                  <>
                <button
                  className={classNames('property-box-image hover-zoom', {
                    'hover-zoom': !video
                  })}
                  // key={index}
                >
                  <div className="gatsby-image-wrapper">
                    <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[0]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 1" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                      <ShowProcessedImage
                        images={images1[0]}
                        attr={{ className: '', alt: '' }}
                        transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
                    </Link>
                  </div>
                </button>
                <button className={"property-box-image hover-zoom"}>
                  <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {/* <img src={noImg} /> */}
                    <Noimg imagename="coming-soon-image.Image.searchResults" />
                    </Link>
                  </div>
                </button>
                <button className={"property-box-image hover-zoom"}>
                  <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {/* <img src={noImg} /> */}
                    <Noimg imagename="coming-soon-image.Image.searchResults" />
                    </Link>
                  </div>
                </button>
                </>
                :
                images1?.length === 2 ?
                <>
              <button
                className={classNames('property-box-image hover-zoom', {
                  'hover-zoom': !video
                })}
                // key={index}
              >
                <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                  {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[0]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 2" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                    <ShowProcessedImage
                      images={images1[0]}
                      attr={{ className: '', alt: '' }}
                      transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
                  </Link>
                </div>
              </button>
              <button
                className={classNames('property-box-image hover-zoom', {
                  // 'hover-zoom': index === 0 && !video
                })}
                // key={index}
              >
                <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                  {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[1]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 2" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                    <ShowProcessedImage
                      images={images1[1]}
                      attr={{ className: '', alt: '' }}
                      transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
                  </Link>
                </div>
              </button>
              <button className={"property-box-image hover-zoom"}>
                <div className="gatsby-image-wrapper">
                <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                  {/* <img src={noImg} /> */}
                  <Noimg imagename="coming-soon-image.Image.searchResults" />
                  </Link>
                </div>
              </button>
              </>
             :
             images1?.length === 3 ?
             <>
           <button
             className={classNames('property-box-image hover-zoom', {
               'hover-zoom': !video
             })}
             // key={index}
           >
             <div className="gatsby-image-wrapper">
               <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
               {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[0]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 3" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                 <ShowProcessedImage
                   images={images1[0]}
                   attr={{ className: '', alt: '' }}
                   transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
               </Link>
             </div>
           </button>
           <button
             className={classNames('property-box-image hover-zoom', {
               // 'hover-zoom': index === 0 && !video
             })}
             // key={index}
           >
             <div className="gatsby-image-wrapper">
               <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
               {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[1]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 3" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                 <ShowProcessedImage
                   images={images1[1]}
                   attr={{ className: '', alt: '' }}
                   transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
               </Link>
             </div>
           </button>
           <button
             className={classNames('property-box-image hover-zoom', {
               // 'hover-zoom': index === 0 && !video
             })}
             // key={index}
           >
             <div className="gatsby-image-wrapper">
               <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
               {nostats ?
              <>
                {images1 &&
                  images1 ?
                    <ImageTransform
                      imagesources={images1[2]?.url}
                      // renderer="srcSet"
                      imagename={"offplan.upload_images.searchResults"}
                      attr={{ alt: 'New Homes', className: "no-image-style 3" }}
                      imagetransformresult={processedImages}
                      id={id}
                    />
                  :
                    <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults" />
                  
                }</>
              :
                 <ShowProcessedImage
                   images={images1[2]}
                   attr={{ className: '', alt: '' }}
                   transforms={collection === "newhomes" ? imageConfig.offplan.searchResults.sizes : imageConfig.property.searchResults.sizes} />
              }
               </Link>
             </div>
           </button>
          
           </>
           :            
null

              // ))
              :
              <>
                <button className={"property-box-image hover-zoom"}>
                  <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {/* <img src={noImg} /> */}
                    <Noimg imagename="coming-soon-image.Image.searchResults" />
                    </Link>
                  </div>
                </button>
                <button className={"property-box-image hover-zoom"}>
                  <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {/* <img src={noImg} /> */}
                    <Noimg imagename="coming-soon-image.Image.searchResults" />
                    </Link>
                  </div>
                </button>
                <button className={"property-box-image hover-zoom"}>
                  <div className="gatsby-image-wrapper">
                  <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} to={url}>
                    {/* <img src={noImg} /> */}
                    <Noimg imagename="coming-soon-image.Image.searchResults" />
                    </Link>
                  </div>
                </button>
              </>
            }
      </div>
      <div className="property-box__content">
        {children}
        {hidebtn ?
              null
              :

        <div className="property-box__details">
          <Row className="justify-content-between g-0">
            <Col xs="auto">
              <Row xs="12" md="auto" className="g-0">
                {bed ? (
                  <Col className="property-box__icon-col d-flex align-items-center me-2_4">
                    {collection === "newhomes" ? <>{bedroom_text ? 
                    <> <i className="icon icon--bed newhome-right ms-0_8"></i> {bedroom_text} bedrooms </> :
                     <></>}
                     </> :
                      <>{bed} <i className="icon icon--bed ms-0_8 ms-md-1_2"></i></>}
                  </Col>
                ) : null}
                {bathroom ? (
                  <Col className="property-box__icon-col d-flex align-items-center me-2_4">
                    {bathroom}
                    <i className="icon icon--bath ms-0_8 ms-md-1_2"></i>
                  </Col>
                ) : null}
                {room ? (
                  <Col className="d-flex align-items-center">
                    {room}
                    <i className="icon icon--chair ms-0_8 ms-md-1_2"></i>
                  </Col>
                ) : null}
              </Row>
            </Col>
              <Col xs="12" md="auto" className="property-box__details-second">
                <Row className="g-0 justify-content-between">
                  <Col xs="auto">
                    <Link onClick={() => { sessionStorage.setItem('searchindex', id) }} class="link-icon blue-link-hover d-flex align-items-center"
                      to={url}
                    >
                      <div
                        className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                      >
                        Details
                      </div>
                      <i className={classNames(`icon icon--eye`)}></i>
                    </Link>
                    {/* <LinkIcon text="Details" icon="eye" /> */}
                  </Col>
                  <Col xs="auto" className="ms-1_2 ms-md-4_6 ms-lg-1_2 ms-xl-3_2">
                    {/* <LinkIcon text="Enquire" /> */}
                    <a class="link-icon blue-link-hover d-flex align-items-center"
                      // to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                      onClick={onClick}
                      href="javascript:void(0)"
                    >
                      <div
                        className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                      >
                        Enquire
                      </div>
                      <i className={classNames(`icon icon--arrow-up-right`)}></i>
                    </a>
                  </Col>
                </Row>
              </Col>
            
          </Row>
        </div>
}
      </div>
      <Modal
        modalShow={modalShow}
        modalContent={modalContent}
        closeModal={closeModal}
      />
    </div>
  )
}
export default NewHomePropertyBox